import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
//Offline
import OfflineProjectList from './pages/local/ProjectsPage';
import OfflineProjectDetails from './pages/local/ProjectDetailsPage';
import OfflineProjectDetails_EDIT from './pages/local/EditProjectPage';
import OfflineProjectSetting from './pages/local/ProjectSettingsPage';
import OfflineCreateProject from './pages/local/CreateProjectPage';
import OfflineCalculator from './pages/local/ProjectCalculatorPage';
import OfflineStats from './pages/local/ProjectStats';
import OfflineAddWords from './pages/local/AddWordsPage';

import Landing from './pages/LandingPage';

import Login from './pages/online/LoginPage';
//Online
import OnlineProjectDetails from './pages/online/OnlineProjectDetailsPage';
import OnlineProjectList from './pages/online/OnlineProjectList';
import OnlineCreateProject from './pages/online/OnlineCreateProject';
import OnlineAddWords from './pages/online/OnlineAddWordsPage';
import OnlineSetting from './pages/online/OnlineProjectSettingsPage';
import OnlineCalculator from './pages/online/OnlineCalculator';
import OnlineStats from './pages/online/OnlineProjectStats';

import Registration from './pages/online/RegistrationPage';
function App() {


  return (

      <Routes>

        {/* wybór trybu */}
        <Route path="/" element={<Landing />} />

        {/* OFFLINE */}
        <Route path="/local" element={<OfflineProjectList />} />
        <Route path="/offline/project/:id" element={<OfflineProjectDetails />} />
        <Route path="/offline_edit/project/:id" element={<OfflineProjectDetails_EDIT />} />
        <Route path="/local/project/:id/setting" element={<OfflineProjectSetting />} />
        <Route path="/offline/CreateProject" element={<OfflineCreateProject />} />
        <Route path="/local/:id/Calculator" element={<OfflineCalculator />}/>
        <Route path="/local/:id/Stats" element={<OfflineStats />}/>
        <Route exact path="/local/:id/AddWords" element={<OfflineAddWords />}/>

        {/* ONLINE */}
        <Route path="/login" element={<Login />} />
        <Route path="/registration" element={<Registration />} />

        <Route path="/online" element={<OnlineProjectList />} />
        <Route path="/online/project/:id" element={<OnlineProjectDetails />} />
        <Route path="/online/project/:id/setting" element={<OnlineSetting />} />
        <Route path="/online/OnlineCreateProject" element={<OnlineCreateProject/>}/>
        <Route exact path="/online/project/:id/AddWords" element={<OnlineAddWords/>}/>
        <Route exact path="/online/project/:id/Calculator" element={<OnlineCalculator/>}/>
        <Route exact path="/online/project/:id/Stats" element={<OnlineStats/>}/>

      </Routes>

   
  ); 
}

export default App;
